import { useQuery } from "@tanstack/react-query";
import type { ActionDto, Page } from "@audit-plan/shared";
import { api } from "./client";
import { unwrap } from "./audits";

export type ActionFilters = { q?: string; status?: string; overdue?: boolean; supplierId?: string; auditId?: string; ncId?: string };

export function useActions(f: ActionFilters = {}, enabled = true) {
  return useQuery({ queryKey: ["actions", "b", f], queryFn: async () => unwrap(await api.get<ActionDto[] | Page<ActionDto>>("/actions", f)), enabled });
}

export function useAction(id?: string | null) {
  return useQuery({ queryKey: ["action", id], queryFn: () => api.get<ActionDto>(`/actions/${id}`), enabled: !!id });
}
